import { createSlice } from '@reduxjs/toolkit';
import { GOOGLE_MAP_API_KEY } from '../../../components/google-map-location-field/constants';
import { GoogleMapAuthState } from './types';

const initialGoogleMapAuthState: GoogleMapAuthState = {
  isError: GOOGLE_MAP_API_KEY ? false : true,
};

const googleMapAuthSlice = createSlice({
  name: 'google-map-auth',
  initialState: initialGoogleMapAuthState,
  reducers: {
    setGoogleMapAuthToError(state) {
      state.isError = true;
    },
  },
});

export const { setGoogleMapAuthToError } = googleMapAuthSlice.actions;
export const googleMapAuthReducer = googleMapAuthSlice.reducer;
